// Navigation Bar SECTION
const navBar = {
  show: true,
};

// Main Body SECTION
const mainBody = {
  gradientColors: "#4484ce, #1ad7c0, #ff9b11, #9b59b6, #ff7f7f, #ecf0f1",
  firstName: "Umayanga",
  middleName: "",
  lastName: "Madushan",
  message: " Passionate about changing the world with technology. ",
  icons: [
    {
      image: "fa-github",
      url: "https://github.com/UtopiaLab",
    },
    {
      image: "fa-facebook",
      url: "https://www.facebook.com/umayangalk",
    },
    {
      image: "fa-youtube",
      url: "https://www.youtube.com/c/SinhalaWebScience/",
    },
    {
      image: "fa-linkedin",
      url: "https://www.linkedin.com/in/umayangamadushan/",
    },
    {
      image: "fa-twitter",
      url: "https://www.twitter.com/umayangalk/",
    },
  ],
};

// ABOUT SECTION
// If you want the About Section to show a profile picture you can fill the profilePictureLink either with:
//a) your Instagram username
//      i.e:profilePictureLink:"johnDoe123",
//b) a link to an hosted image
//      i.e:profilePictureLink:"www.picturesonline.com/johnDoeFancyAvatar.jpg",
//c) image in "editable-stuff" directory and use require("") to import here,
//      i.e: profilePictureLink: require("../editable-stuff/hashirshoaeb.png"),
//d) If you do not want any picture to be displayed, just leave it empty :)
//      i.e: profilePictureLink: "",
// For Resume either provide link to your resume or import from "editable-stuff" directory
//     i.e resume: require("../editable-stuff/resume.pdf"),
//         resume: "https://docs.google.com/document/d/13_PWdhThMr6roxb-UFiJj4YAFOj8e_bv3Vx9UHQdyBQ/edit?usp=sharing",

const about = {
  show: true,
  heading: "About Me",
  imageLink: require("../editable-stuff/umayanga.jpg"),
  imageSize: 375,
  message:
    "My name is Umayanga Madushan. I'm an undergraduate of BSc (Hons) in Information Technology from University of Sri Jayewardenepura. I have experience in IT-related fields such as programming, designing, hardware, Internet of Things, Networking, Database Management, and administrative support. Excellent team player with quick decision-making skills and the ability to remain calm under stress. Also I'm an NVQ certificate holder in ICT with proven research and communication skills. Currently I'm working as a Magento full-stack developer & react frontend developer.",
  resume: require("../editable-stuff/CV_UmayangaMadushan_v3.3.pdf"),
};

// PROJECTS SECTION
// Setting up project lenght will automatically fetch your that number of recently updated projects, or you can set this field 0 to show none.
//      i.e: reposLength: 0,
// If you want to display specfic projects, add the repository names,
//      i.e ["repository-1", "repo-2"]
const repos = {
  show: true,
  heading: "Recent Projects",
  gitHubUsername: "UtopiaLab", //i.e."johnDoe12Gh"
  reposLength: 4,
  specificRepos: [],
};

// Leadership SECTION
const leadership = {
  show: true,
  heading: "Education",
  message:
    `I got 9A's for GCE O/L with ICT in 2010. Then I passed GCE A/L with ICT and selected for university in 2016. My primary school was WP/MT Bellana Maha Vidyalaya and secondary school was C.W.W. Kannangara Central College, Mathugama.`,
  message2:
    `ICT was the favorite field of study since my childhood. My primary goal is to become an all rounder in ICT and be a solution for any ICT issue. Then I love to learn and improve my skills in any subcategory of ICT.`,
  
  images: [
    { 
      img: require("../editable-stuff/sjp.jpg"), 
      label: "Higher Education", 
      paragraph: "University of Sri Jayewardenepura" 
    },
    { 
      img: require("../editable-stuff/kcc.jpg"), 
      label: "Secondary School", 
      paragraph: "C. W. W. Kannangara Central College, Mathugama" 
    },
    { 
      img: require("../editable-stuff/bmv.jpg"), 
      label: "Primary School", 
      paragraph: "WP/MT Bellana Maha Vidyalaya, Bellana" 
    },
  ],
  imageSize: {
    width:"600",
    height:"400"
  }
};

// SKILLS SECTION
const skills = {
  show: true,
  heading: "Skills",
  hardSkills: [
    { name: "Python", value: 90 },
    { name: "SQL", value: 75 },
    { name: "Data Structures", value: 85 },
    { name: "C/C++", value: 65 },
    { name: "JavaScript", value: 70 },
    { name: "React", value: 65 },
    { name: "HTML/CSS", value: 95 },
    { name: "PHP", value: 80 },
  ],
  softSkills: [
    { name: "Goal-Oriented", value: 80 },
    { name: "Collaboration", value: 90 },
    { name: "Positivity", value: 75 },
    { name: "Adaptability", value: 90 },
    { name: "Problem Solving", value: 75 },
    { name: "Empathy", value: 80 },
    { name: "Organization", value: 75 },
    { name: "Creativity", value: 90 },
  ],
};

// GET IN TOUCH SECTION
const getInTouch = {
  show: true,
  heading: "Get In Touch",
  message:
    "I'm currently looking for developing opportunities in php, javascript or python development sides to gain my career experience! If you know of any opportunities available, if you have any questions, or if you just want to say hi, please feel free to email me at",
  email: "umayangamadushan@gmail.com",
};

const experiences = {
  show: true,
  heading: "Experiences",
  data: [
    {
      role: 'Freelance Graphic/Web Designer',// Here Add Company Name
      companylogo: require('../assets/img/fiverr.jpg'),
      date: 'Feb 2013 – Present',
    },
    {
      role: 'Intern',
      companylogo: require('../assets/img/slt.jpg'),
      date: 'June 2017 – December 2017',
    },
    {
      role: 'Associate Software Engineer',
      companylogo: require('../assets/img/NeoSolax.png'),
      date: 'September 2021 – Present',
    },
    {
      role: 'Frontend Developer (Part Time)',
      companylogo: require('../assets/img/helamid.png'),
      date: 'October 2021 – Present',
    },
  ]
}

// Blog SECTION
// const blog = {
//   show: false,
// };

export { navBar, mainBody, about, repos, skills, leadership, getInTouch, experiences };
